<app-sub-header [pageTitle]="'CarWashUse' | translate"></app-sub-header>

<div class="padded-container">
  <form (ngSubmit)="saveClick()">
    <dx-form>
      <dxi-item>
        <dxo-label text="{{ 'CarWashCosts' | translate }}"></dxo-label>
        <dx-number-box [(value)]="carWashAmount" 
               [min]="0" 
               [max]="1000" 
               [step]="0.01" 
               [showSpinButtons]="true" 
               [format]="{ type: 'currency', currency: 'EUR', precision: 2 }" 
               class="full-width-button">
</dx-number-box>
      </dxi-item>
      <dxi-item>
        <dx-select-box
  [dataSource]="carWashCompaniesResponse?.companyList || []"
  [(value)]="carWashCompanyId"
  displayExpr="name"
  placeholder="{{ 'SelectCarWashCompany' | translate }}"
  valueExpr="id">
</dx-select-box>
      </dxi-item>
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="success" (onClick)="saveClick()"></dx-button>
      </dxi-item>
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="navigateToVoucher()"></dx-button>
      </dxi-item>
    </dx-form>
  </form>

  <div *ngIf="carWashResponse">
    <div class="container">
      <div *ngIf="carWashResponse">
        <label>{{ 'CarWashUse' | translate }}</label>
        <div *ngFor="let group of carWashResponse.washList">
          <div class="car-wash-group">
            <label>{{ 'Amount' | translate }}</label>
            <dx-number-box [value]="group.amount ?? 0" class="full-width-button" [readOnly]="true"></dx-number-box>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dx-popup [(visible)]="popupVisibleError" title="{{ 'Paziņojums' | translate }}" [width]="isMobile ? '100%' : '60%'"
  [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile" [hideOnOutsideClick]="false" [showCloseButton]="true">
    <div *dxTemplate="let data of 'content'">
      <p [innerHTML]="errorMessage"></p>
    </div>
  </dx-popup>
</div>